export default __webpack_public_path__ + "static/media/ai_mic.ebb0e617.svg";